import { TableColumnsType } from "antd";
import { BasePagination } from "api/interfaces/commonInterface.interface";
import { SubscriptionRequestTable } from "api/interfaces/subscription.interface";
import { CommonTable } from "components/atoms/table/AntdTable";
import RequestKeyModal from "pages/subscription/modal/requestKey";
import React from "react";

interface Props {
  request: boolean;
  onModal: () => void;
  columns: TableColumnsType<SubscriptionRequestTable>;
  data: SubscriptionRequestTable[];
  isFetching: boolean;
  queryInfo: BasePagination;
  onChangePage: (page: number) => void;
}

export default function SubscriptionRequestHistoryPresenter(props: Props) {
  return (
    <>
      <CommonTable
        columns={props.columns}
        dataSource={props.data}
        loading={props.isFetching}
        queryInfo={props.queryInfo}
        onChangePage={props.onChangePage}
      />
      {props.request && <RequestKeyModal onModal={() => props.onModal()} />}
    </>
  );
}
